if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.units = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.units[el.dataset.unit] = el;
      });
      this.daysBox = this.querySelector('[data-unit-box="days"]');
      this.expiredEl = this.querySelector('.countdown-timer__expired');
      this.section = this.closest('.countdown-timer');

      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    // Parses "+05:30" / "-04:00" into minutes east of UTC.
    parseOffset(value) {
      const match = /^([+-])(\d{1,2}):?(\d{2})?$/.exec((value || '').trim());
      if (!match) return 0;
      const minutes = parseInt(match[2], 10) * 60 + parseInt(match[3] || '0', 10);
      return match[1] === '-' ? -minutes : minutes;
    }

    getEndTime() {
      const mode = this.dataset.mode;
      const now = Date.now();

      if (mode === 'daily') {
        const [h, m] = (this.dataset.dailyTime || '23:59').split(':').map((n) => parseInt(n, 10) || 0);
        const offsetMs = this.parseOffset(this.dataset.utcOffset) * 60000;
        // Work in the store's timezone by shifting "now" into it.
        const local = new Date(now + offsetMs);
        let end = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), h, m, 0) - offsetMs;
        if (end <= now) end += 86400000;
        return end;
      }

      if (mode === 'session') {
        const durationMs = (parseInt(this.dataset.duration, 10) || 60) * 60000;
        const key = this.dataset.storageKey;
        let end = null;
        try {
          end = parseInt(localStorage.getItem(key), 10);
        } catch (e) {}
        if (!end || end <= now) {
          end = now + durationMs;
          try {
            localStorage.setItem(key, String(end));
          } catch (e) {}
        }
        return end;
      }

      const end = Date.parse(this.dataset.end);
      return isNaN(end) ? now : end;
    }

    pad(n) {
      return String(n).padStart(2, '0');
    }

    tick() {
      const remaining = Math.max(0, this.getEndTime() - Date.now());
      let seconds = Math.floor(remaining / 1000);

      const days = Math.floor(seconds / 86400);
      seconds -= days * 86400;
      const hours = Math.floor(seconds / 3600);
      seconds -= hours * 3600;
      const minutes = Math.floor(seconds / 60);
      seconds -= minutes * 60;

      // Fold days into hours when the days box is disabled.
      const values = {
        days,
        hours: this.units.days ? hours : hours + days * 24,
        minutes,
        seconds,
      };

      Object.keys(this.units).forEach((unit) => {
        const text = this.pad(values[unit]);
        if (this.units[unit].textContent !== text) this.units[unit].textContent = text;
      });

      if (this.daysBox) {
        this.daysBox.hidden = this.dataset.hideZeroDays === 'true' && days === 0;
      }

      if (remaining <= 0) this.onExpired();
    }

    onExpired() {
      clearInterval(this.interval);
      this.classList.add('is-expired');
      const action = this.dataset.expiredAction;

      // Keep the section visible in the theme editor so it stays editable.
      if (action === 'hide' && !window.Shopify?.designMode && this.section) {
        this.section.hidden = true;
      } else if (action === 'message' && this.expiredEl) {
        this.expiredEl.hidden = false;
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
